import React, { useEffect } from 'react'

import {
  Form,
  Grid,
  SelectForm,
  Button
} from 'components'
import { MagnifyingGlassIcon } from 'components/Icons'
import { useFineGraduation } from 'pages/GST/Registers/FineGraduation/context'
import { useFormContext } from 'react-hook-form'
import { IGraduacaoMultasGetAllParams } from 'services/GST/GraduacaoMultas'
import { SPACING, FUNCTIONS } from 'utils'

import { IForm } from '../../types'


interface ISearchFieldsProps {
  refreshTable: (_props: IGraduacaoMultasGetAllParams) => void
  isFirstGet: boolean
}

const SearchFields: React.FC<ISearchFieldsProps> = ({
  refreshTable,
  isFirstGet
}) => {
  const {
    control,
    handleSubmit,
    reset,
    formState: { errors }
  } = useFormContext<IForm>()

  const { 
    handleGetAreas, 
    handleGetInfracoes, 
    handleGetQuantidadeFuncionarios,
    areasList,
    faixaFuncionariosList,
    infracoesList, 
  } = useFineGraduation()

  const handleResetForm = () => {
    reset()
    handleGetAreas()
    handleGetQuantidadeFuncionarios()
    handleGetInfracoes()
    refreshTable({
      pageNumber: 1
    })
  }

  const handleSubmitForm = (form: IForm) => {
    refreshTable({
      ...FUNCTIONS.filterObject(form, Boolean),
      pageNumber: 1,
    })
  }

  useEffect(() => {
    if (isFirstGet) {
      handleGetAreas()
      handleGetQuantidadeFuncionarios()
      handleGetInfracoes()
    }
  }, [isFirstGet])

  return (
    <Form
      onSubmit={handleSubmit(handleSubmitForm)}
      marginBottom={SPACING.spacing10}
    >
      <Grid
        gridCols="2fr 0.9fr 0.9fr 1fr 1fr 2fr"
        gridGap={`0 ${SPACING.spacing20}`}
        margin={`${SPACING.spacing10} 0 ${SPACING.spacing10} 0`}
      >
        <SelectForm
          control={control}
          errors={errors}
          placeholder="Selecione"
          clearSelect={true}
          defaultValue={''}
          listOptions={areasList?.map((areaAtuacao) => (
            { label: areaAtuacao?.descricao, value: areaAtuacao?.codigoDeAreaDeAtuacao}
          ))}
          label="Área de Atuação"
          formValue="txAreaAtuacao"
        />
        <SelectForm
          control={control}
          errors={errors}
          defaultValue={''}
          placeholder="Selecione"
          clearSelect={true}
          listOptions={faixaFuncionariosList?.map((qtdFuncionario) => (
            { label: qtdFuncionario?.descricao.toString(), value: qtdFuncionario?.faixaId }
          ))}
          label="Número de Funcionários"
          formValue="idFaixa"
        />
        <SelectForm
          control={control}
          errors={errors}
          defaultValue={''}
          placeholder="Selecione"
          clearSelect={true}
          listOptions={infracoesList?.map((infracao) => (
            { label: infracao?.nuNivelInfracao, value: infracao?.idInfracao }
          ))}
          label="Infração"
          formValue="idInfracao"
        />
        <div style={{ display: 'flex', justifyContent: 'baseline' }}>
          <Button
            variantButton="text"
            text="LIMPAR"
            width={'max-content'}
            onClick={handleResetForm}
            marginRight={SPACING.spacing20}
          />
          <Button
            width={'max-content'}
            endIcon={<MagnifyingGlassIcon />}
            marginTop={SPACING.spacing10}
            marginRight={SPACING.spacing200}
            type="submit"
            text="PESQUISAR"
          />
        </div>
      </Grid>
    </Form>
  )
}

export default SearchFields